import { Children, useEffect } from 'react';

export function HelmetProvider({ children }) {
  return children;
}

export function Helmet({ children }) {
  useEffect(() => {
    const managedNodes = document.head.querySelectorAll('[data-managed-helmet="true"]');
    managedNodes.forEach((node) => node.remove());

    const childArray = Children.toArray(children);

    childArray.forEach((child) => {
      if (!child || !child.type || !child.props) {
        return;
      }

      if (child.type === 'title') {
        document.title = child.props.children;
        return;
      }

      if (child.type === 'meta') {
        const meta = document.createElement('meta');
        Object.entries(child.props).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            meta.setAttribute(key, String(value));
          }
        });
        meta.setAttribute('data-managed-helmet', 'true');
        document.head.appendChild(meta);
      }

      if (child.type === 'link') {
        const link = document.createElement('link');
        Object.entries(child.props).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            link.setAttribute(key, String(value));
          }
        });
        link.setAttribute('data-managed-helmet', 'true');
        document.head.appendChild(link);
      }
    });
  }, [children]);

  return null;
}
